import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import "../../../../state/state/actions.js";
import { PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID } from "../../../../state/state/constants.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { PupillaryDistanceContent } from "../../../components/PupillaryDistanceContent/steps/components/PupillaryDistanceContent/PupillaryDistanceContent.js";
import { StepWithAlerts } from "../../../components/StepWithAlerts/steps/components/StepWithAlerts/StepWithAlerts.js";
import { PrescriptionUploadFormContainer } from "../../components/PrescriptionUploadForm/steps/PrescriptionUploadStep/components/PrescriptionUploadForm/PrescriptionUploadFormContainer.js";
/* empty css                            */
const PrescriptionUploadStep = ({
  description,
  image,
  ...stepWithAlertsProps
}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const supportedFilesLabelKey = "products.glasses.upload.supportedFileTypes";
  const privacyPolicyLabelValue = getFormattedLabel("products.glasses.upload.privacyPolicyLink", {
    parseLink: true,
    openLinksInNewTab: true
  });
  const hasExtraInfo = Boolean(description || image);
  return /* @__PURE__ */ React.createElement(StepWithAlerts, { ...stepWithAlertsProps }, /* @__PURE__ */ React.createElement("div", { className: "rx-upload-step" }, hasExtraInfo && /* @__PURE__ */ React.createElement(PupillaryDistanceContent, { description, image }), /* @__PURE__ */ React.createElement(PrescriptionUploadFormContainer, { className: "rx-upload-step__upload-form" }), /* @__PURE__ */ React.createElement(Text, { id: PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID }, getLabel(supportedFilesLabelKey)), /* @__PURE__ */ React.createElement("div", { className: "rx-upload-step__privacy" }, /* @__PURE__ */ React.createElement(Icon, { name: "info" }), /* @__PURE__ */ React.createElement(Text, null, privacyPolicyLabelValue))));
};
export {
  PrescriptionUploadStep
};
//# sourceMappingURL=PrescriptionUploadStep.js.map
